module.exports = __webpack_public_path__ + "img/facebook.30f2798f.svg";